import { render, staticRenderFns } from "./TableFooter.vue?vue&type=template&id=70697575&scoped=true"
import script from "./TableFooter.vue?vue&type=script&lang=js"
export * from "./TableFooter.vue?vue&type=script&lang=js"
import style0 from "./TableFooter.vue?vue&type=style&index=0&id=70697575&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70697575",
  null
  
)

export default component.exports